import { render, staticRenderFns } from "./skus.vue?vue&type=template&id=a67b2b8a&scoped=true&"
import script from "./skus.vue?vue&type=script&lang=js&"
export * from "./skus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b2b8a",
  null
  
)

export default component.exports